import React from "react";
import { Button, Grid, Typography } from "@mui/material";
import "../../assets/css/icon.css";

const ModalSuccessAml = ({ onClose, isIta, status }) => {
  const isApproved = status === "approved" || status === "pending_confirmation";

  return (
    <Grid
      container
      item
      xs={11}
      md={5}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "100%",
        width: { xs: "90%", sm: "80%" },
        borderRadius: "16px",
        outline: "none",
      }}
    >
      {/* ── Header ── */}
      <Grid
        item
        xs={12}
        style={{
          height: "60px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
        }}
      >
        <Grid item xs={1} style={{ marginLeft: "15px" }}>
          {isApproved ? (
            <div className="icon-modal-otp" />
          ) : (
            <div className="icon-check-success" />
          )}
        </Grid>
        <Grid
          item
          xs={11}
          sx={{ ml: { xs: 3, sm: 1 } }}
          // style={{ paddingRight: "15px" }}
        >
          <Typography
            className="color-blue-dark"
            style={{ fontSize: "18px", fontWeight: 600 }}
          >
            {isApproved
              ? isIta
                ? "Procedura non attiva"
                : "Procedure not active"
              : isIta
                ? "Modulo inviato con successo"
                : "Form successfully submitted"}
          </Typography>
        </Grid>
      </Grid>

      {/* ── Body ── */}

      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          className="color-blue-dark"
          style={{ padding: "10px 15px 0px 15px", marginTop: "20px" }}
        >
          {isApproved ? (
            isIta ? (
              <>
                Questa procedura è inattiva in quanto il relativo modulo
                anti-riciclaggio è stato già raccolto oppure archiviato. Per
                domande o dubbi scrivere a{" "}
                <a
                  href="mailto:amministrazione@lexia.it"
                  className="color-purple"
                >
                  amministrazione@lexia.it
                </a>
                .
              </>
            ) : (
              <>
                This procedure is inactive as the related anti-money laundering
                form has already been collected or archived. For questions or
                concerns, please write to{" "}
                <a
                  href="mailto:amministrazione@lexia.it"
                  className="color-purple"
                >
                  amministrazione@lexia.it
                </a>
                .
              </>
            )
          ) : isIta ? (
            "Il modulo anti-riciclaggio è stato inviato correttamente all'amministrazione LEXIA."
          ) : (
            "The anti-money laundering form has been successfully submitted to the LEXIA administration."
          )}
        </Typography>
        <Typography
          className="color-blue-dark"
          style={{ padding: "8px 15px 0px 15px" }}
        >
          {isApproved
            ? isIta
              ? ""
              : ""
            : isIta
              ? "Grazie per la collaborazione! Al momento non sono necessarie ulteriori azioni da parte tua."
              : "Thank you for your collaboration! No further action is required from you at this time."}
        </Typography>
      </Grid>

      {/* ── Footer ── */}
      <Grid container item xs={12}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px",
          }}
        >
          <Button
            className="button-bg-purple"
            sx={{ width: "120px" }}
            onClick={() => (window.location.href = "https://www.lexia.it")}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {isIta ? "Chiudi" : "Close"}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalSuccessAml;
